<template>
    <v-container fluid>
      <material-card icon="mdi-format-list-bulleted-square" inline title="Module Listing">
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
            <v-btn elevation="1"  v-on:click="addUser()" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
              <v-icon left>mdi-plus</v-icon>
              Add
            </v-btn>
          </v-card-text>
          <v-divider class=" my-0 " />
        <v-data-table
        v-if="data.length"
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
          :headers="headers"
          :items="data"
          :search="search"
        >
          <template v-slot:top>
            <v-dialog v-model="deleteItem" max-width="500px">
              <v-card>
                <v-card-title class="headline">Are you sure you want to delete this item? </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="lightblue" text @click="closeDelete">Cancel </v-btn>
                  <v-btn color="lightblue" text @click="deleteModule(deleteItem)">OK </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <template v-slot:item.isAuth="{ item }">
            {{ item.isAuth === true ? 'Yes' : 'No' }}
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
          <template v-slot:item.module="{ item }">
            <span v-for="m in item.subDashboards" :key="m.id">
              <v-chip small dark class="ma-1 font-weight-medium" color="darkblue lighten-1">
                {{ m && m.name ? m.name : '' }}
              </v-chip>
            </span>
          </template>

          <template v-slot:item.actions="{ item }">
            {{ item.actions }}
            <router-link :to="{ name: 'DynamicLevelEdit', params: { uniqueId: item.id } }">
              <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                <v-icon small> mdi-pencil</v-icon>
              </v-btn>
            </router-link>
            <v-btn v-if="!item.deletedAt" @click.prevent="deleteItemAlert(item)" class="px-2 ml-1 ma-1" color="error" min-width="0" small>
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </material-card>
    <loading-icon :value="isLoading" />
    </v-container>
</template>

<script>
// @ is an alias to /src
// import stores from '@/stores'
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import _ from 'lodash'

export default {
  name: 'ListModule',
  components: { MaterialCard },
  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],
      current: 1,
      rangeBefore: 3,
      rangeAfter: 1,
      order: 'is-right',
      size: '',
      total: '',
      search: '',
      isSimple: false,
      isRounded: false,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      isModalActive: false,
      trashObject: null,
      paginated: false,
      deleteItem: null,
      perPage: 10,
      checkedRows: [],
      content: '',
      models: [],
      loadingComponent: null,
      isLoading: false,
      headers: [
        { text: 'Module Name', sortable: true, value: 'name' },
        { text: 'isAuth', value: 'isAuth', sortable: true },
        { text: 'Module', value: 'module', sortable: false },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },
  created () {
    this.getModuleList()
  },
  computed: {},
  methods: {
    addUser: async function () {
      this.$router.push({ name: 'DynamicLevel' })
    },
    deleteItemAlert: function (item) {
      if (item) {
        this.deleteItem = item
      }
    },
    closeDelete: function () {
      this.deleteItem = null
    },
    getModuleList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/dashboard-module`)
        this.data = response.data
        this.total = this.data.length
        this.isLoading = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('error in fetching User : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    deleteModule: async function (adminUserID) {
      let ref = this

      this.$dialog.warning({
        title: 'Delete User',
        text: 'Do you really want to <b>delete</b> this record?',
        false: {
          text: 'No'
        },
        true: {
          color: 'red',
          text: 'Yes',
          handle: async () => {
            try {
              ref.isLoading = true
              await http.delete(`${constants.API_URL}/api/dashboard-module/${adminUserID}`)
              ref.isLoading = false
              await ref.getModuleList()

              return ref.$dialog.info({
                title: 'Success',
                text: 'Deleted Module Successfully'
              })
            } catch (e) {
              ref.isLoading = false
              const errorMessage = (e && e.response && e.response.data.message) || e.message
              return ref.$dialog.error({
                title: 'Error',
                text: errorMessage
              })
            }
          } }
      })
    }
  }
}
</script>
